import CustomFieldsInput from "../../../../../components/FieldComponents/CustomFieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";

const AccountDepartment = (props) => {
  const { value, onChange } = props;
  const style = Style();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <CustomFieldsInput
          label={t("department")}
          validationMessage={props.errors?.accountDepartment?.message}
          id="accountDepartment"
          placeholder={t("enter_department")}
          name="accountDepartment"
          value={value}
          onChange={onChange}
          inputClassName={mergeClasses(style.textboxInput)}
          validation={props.register("accountDepartment", {
            required: `${t("validation_message.department_is_required")}`,
          })}
        />
      </Stack>
    </>
  );
};

export default AccountDepartment;
